import { Link } from "react-router-dom";

const steps = ["Workplace", "Your needs", "Recommendation"];
const hpLogoUrl = "https://customer-assets-jai6qajn.emergentagent.net/job_poly-gift-winner/artifacts/q1vudjkl_image.png";

export default function StepHeader({ step = 1, compact = false, progressLabel = "" }) {
  return (
    <header className={`topbar ${compact ? "topbar-compact" : ""}`} data-testid="advisor-header">
      <Link to="/" className="brand-lockup" aria-label="HP home" data-testid="advisor-header-logo">
        <img src={hpLogoUrl} alt="HP" className="header-hp-logo" data-testid="hp-header-logo-image" />
      </Link>
      <nav className="step-track" aria-label="Advisor steps" data-testid="step-indicator-pill">
        {steps.map((label, index) => (
          <span key={label} className={`track-step ${index + 1 <= step ? "is-active" : ""}`} data-testid={`step-indicator-${index + 1}`}>
            <b>{index + 1}</b><span>{label}</span>
          </span>
        ))}
      </nav>
      <span className="header-progress" data-testid="header-progress-label">{progressLabel || "Fit Check"}</span>
    </header>
  );
}